/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import i18n functions */
import DashboardGrid from '@/components/layout/DashboardGrid';
import { useI18n } from '@/context/I18nContext';

function ThermalConflictTab() {
    const { t } = useI18n();

    return (
        <DashboardGrid desktopCols={4} desktopRows={["160px", "1fr"]} breakpoint={"2xl"} aria-label={t("Thermal conflict dashboard")}>
            <DashboardGrid.Item as="section" className="dashboard-panel">
                <span>Box1</span>
            </DashboardGrid.Item>

            <DashboardGrid.Item as="section" className="dashboard-panel">
                <span>Box2</span>
            </DashboardGrid.Item>

            <DashboardGrid.Item as="section" className="dashboard-panel">
                <span>Box3</span>
            </DashboardGrid.Item>

            <DashboardGrid.Item as="section" className="dashboard-panel">
                <span>Box4</span>
            </DashboardGrid.Item>

            <DashboardGrid.Item as="section" className="dashboard-panel" desktopColSpan={4}>
                <span>Box5</span>
            </DashboardGrid.Item>
        </DashboardGrid>
    );
}

export default ThermalConflictTab;
